import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const AffiliatesComissionsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "AffiliatesComissionsPage" */ "@circle-react/components/SettingsApp/PaywallsAffiliates/PaywallsAffiliatesCommissions"
    ),
);

export const AffiliatesComissionsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <AffiliatesComissionsComponent />
  </Suspense>
);
